export const SERVICE_PAGES = [
  {
    slug: "camasir-makinesi-servisi-duzce",
    title: "Çamaşır Makinesi Servisi",
    h1: "Düzce Çamaşır Makinesi Servisi",
    tag: "AYNI GÜN YERİNDE ONARIM",
    metaTitle: "Düzce Çamaşır Makinesi Servisi | Nova Teknik",
    meta: "Düzce çamaşır makinesi servisi: su boşaltmama, sıkmada ses, kazan ve kart arızalarında aynı gün yerinde onarım. Tüm markalar, 1 yıl işçilik garantisi. Hemen arayın: 0537 502 21 81.",
    image: "/photos/camasir.jpg",
    desc: "Düzce Merkez ve tüm mahallelerinde çamaşır makinesi tamiri için mobil ekibimiz adresinize gelir. Arızayı cihaz başında tespit eder, fiyatı işlem öncesi net söyleriz; onayınız olmadan işlem yapmayız.",
    faults: [
      "Su boşaltmıyor (pompa arızası)",
      "Sıkmada aşırı ses ve sarsıntı (amortisör)",
      "Kazan dönmüyor (kayış / motor)",
      "Su almıyor (ventil / basınç sivici)",
      "Kapı contası su kaçırıyor",
      "Program başlamıyor (kart arızası)",
      "Suyu ısıtmıyor (rezistans)",
      "Koku ve hijyen bakımı",
    ],
    faqs: [
      ["Hangi markalara bakıyorsunuz?", "Arçelik, Beko, Vestel, Profilo, Bosch, Samsung, LG, Siemens ve diğer tüm markalara hizmet veriyoruz."],
      ["Aynı gün servis mümkün mü?", "Düzce Merkez içindeki taleplerde uygunluk durumuna göre aynı gün adresinize geliyoruz."],
      ["Onarım garantili mi?", "Evet. Değişen parça ve işçilik 1 yıl Nova Teknik garantisi altındadır."],
    ],
  },
  {
    slug: "buzdolabi-tamiri-duzce",
    title: "Buzdolabı Tamir & Bakım",
    h1: "Düzce Buzdolabı Tamiri",
    tag: "KOMPRESÖR & GAZ İŞLEMLERİ",
    metaTitle: "Düzce Buzdolabı Tamiri | Nova Teknik",
    meta: "Düzce buzdolabı tamiri: soğutmama, kompresör değişimi, gaz dolumu ve no-frost arızalarında yerinde servis. 1 yıl garanti. Arayın: 0537 502 21 81.",
    image: "/photos/buzdolabi.jpg",
    desc: "Soğutmayan, ses yapan veya karlanan buzdolabınız için Düzce'nin her mahallesine geliyoruz. Kompresör değişimi ve gaz işlemleri dahil tüm onarımlar profesyonel ekipmanla yapılır.",
    faults: [
      "Soğutmuyor / az soğutuyor",
      "Kompresör arızası ve değişimi",
      "Gaz kaçağı ve gaz dolumu",
      "No-frost fan motoru arızası",
      "Aşırı karlanma / buzlanma",
      "Termostat arızası",
      "Kapı contası değişimi",
      "Sesli ve titrek çalışma",
    ],
    faqs: [
      ["Buzdolabı yerinde mi onarılır?", "Arızaların çoğunu adresinizde çözüyoruz; gaz ve kompresör işlemleri de yerinde yapılabilir."],
      ["Gaz dolumu kalıcı çözüm mü?", "Kaçak noktası tespit edilip onarılmadan gaz basılmaz; önce kaçak giderilir, sonra dolum yapılır."],
      ["Derin dondurucu da bakım kapsamında mı?", "Evet, derin dondurucu ve sanayi tipi soğutuculara da bakıyoruz."],
    ],
  },
  {
    slug: "klima-servisi-duzce",
    title: "Klima Bakım & Onarım",
    h1: "Düzce Klima Servisi",
    tag: "GAZ DOLUMU · MONTAJ · BAKIM",
    metaTitle: "Düzce Klima Servisi | Nova Teknik",
    meta: "Düzce klima servisi: gaz dolumu, hijyen bakımı, montaj-demontaj ve kart tamiri. Aynı gün yerinde hizmet, 1 yıl garanti. Arayın: 0537 502 21 81.",
    image: "/photos/klima-units.jpg",
    desc: "Klimanız soğutmuyor, su damlatıyor veya koku mu yapıyor? Düzce Merkez'de klima bakım, gaz dolumu, montaj ve onarım işlemlerini manifold ölçümüyle, şeffaf şekilde yapıyoruz.",
    faults: [
      "Gaz dolumu (R32 / R410A)",
      "Soğutmuyor / ısıtmıyor",
      "İç ünite su damlatıyor",
      "Kötü koku — filtre ve hijyen bakımı",
      "Kart ve sensör arızası",
      "Montaj ve demontaj",
      "Drenaj hattı tıkanıklığı",
      "Dış ünite ses ve titreşim",
    ],
    faqs: [
      ["Klima bakımı ne sıklıkla yapılmalı?", "Yılda en az bir kez, tercihen yaz sezonu öncesi filtre ve genel bakım öneriyoruz."],
      ["Gaz eksikliği nasıl anlaşılır?", "Manifold ile basınç ölçümü yaparız; gaz eksikse önce kaçak kontrolü, sonra dolum yapılır."],
      ["Yer değişimi / taşıma yapıyor musunuz?", "Evet, klima demontaj ve yeni adrese montaj hizmeti veriyoruz."],
    ],
  },
  {
    slug: "bulasik-makinesi-servisi-duzce",
    title: "Bulaşık Makinesi Servisi",
    h1: "Düzce Bulaşık Makinesi Servisi",
    tag: "YERİNDE TEST & ONARIM",
    metaTitle: "Düzce Bulaşık Makinesi Servisi | Nova Teknik",
    meta: "Düzce bulaşık makinesi servisi: temiz yıkamama, su almama, pompa ve rezistans arızalarında aynı gün yerinde onarım. 1 yıl garanti. Arayın: 0537 502 21 81.",
    image: "/photos/bulasik.jpg",
    desc: "Atölyemizdeki yıkayıcı ürünler test alanında veya adresinizde; bulaşık makinenizin arızasını tespit edip orijinal parçayla onarıyoruz. İşlem öncesi net fiyat, onaysız işlem yok.",
    faults: [
      "Temiz yıkamıyor",
      "Su almıyor",
      "Suyu boşaltmıyor (pompa arızası)",
      "Suyu ısıtmıyor (rezistans)",
      "Su kaçırıyor",
      "Kapı menteşe ve kilit arızası",
      "Pervane ve sepet sorunları",
      "Deterjan / tablet eritmiyor",
    ],
    faqs: [
      ["Makineyi atölyeye mi götürmem gerekiyor?", "Hayır, çoğu arızayı adresinizde çözüyoruz. Gerekirse cihazı test alanımızda kontrol ederiz."],
      ["Ankastre bulaşık makinesine bakıyor musunuz?", "Evet, ankastre ve solo tüm bulaşık makinelerine hizmet veriyoruz."],
      ["Parça değişimi garantili mi?", "Takılan her parça ve işçilik 1 yıl garantimiz altındadır."],
    ],
  },
  {
    slug: "ankastre-servisi-duzce",
    title: "Ankastre, Davlumbaz, Fırın & Ocak",
    h1: "Düzce Ankastre Servisi",
    tag: "FIRIN · OCAK · DAVLUMBAZ",
    metaTitle: "Düzce Ankastre Servisi | Nova Teknik",
    meta: "Düzce ankastre servisi: fırın rezistansı, ocak ateşleme, davlumbaz motoru ve kart arızalarında yerinde bakım-onarım. 1 yıl garanti. Arayın: 0537 502 21 81.",
    image: "/photos/ankastre.jpg",
    desc: "Ankastre fırın, ocak ve davlumbazınız için Düzce Merkez'de yerinde bakım ve onarım. Gaz bağlantılı cihazlarda güvenlik kontrolü önceliğimizdir; işlem öncesi her adımı anlatırız.",
    faults: [
      "Fırın ısıtmıyor (rezistans)",
      "Davlumbaz çekmiyor (motor arızası)",
      "Ocak ateşleme yapmıyor",
      "Fırın fanı sesli çalışıyor",
      "Cam kapak ve menteşe değişimi",
      "Termostat ve kart arızası",
      "Gaz emniyeti (termokupul) arızası",
      "Davlumbaz filtre ve genel bakım",
    ],
    faqs: [
      ["Gazlı cihazlarda güvenlik nasıl sağlanıyor?", "Ocak ve fırınlarda önce gaz kaçağı ve emniyet ventili kontrolü yapılır, onayınız olmadan işlem başlamaz."],
      ["Davlumbaz bacalı mı bacasız mı fark eder mi?", "İki tip davlumbaza da bakım ve motor onarımı yapıyoruz."],
      ["Set üstü ocak da kapsamda mı?", "Evet, ankastre ve set üstü ocak, fırın, davlumbazların tamamına bakıyoruz."],
    ],
  },
  {
    slug: "kucuk-ev-aletleri-duzce",
    title: "Küçük Ev Aletleri Tamiri",
    h1: "Düzce Küçük Ev Aletleri Tamiri",
    tag: "ATÖLYEDE HIZLI ONARIM",
    metaTitle: "Düzce Küçük Ev Aletleri Tamiri | Nova Teknik",
    meta: "Düzce küçük ev aletleri tamiri: süpürge motoru, ütü, mikrodalga, kahve makinesi ve robot süpürge onarımı. Atölyede hızlı çözüm. Arayın: 0537 502 21 81.",
    image: "/photos/atolye.jpg",
    desc: "Elektrikli süpürgeden kahve makinesine kadar tüm küçük ev aletlerini atölyemizde onarıyoruz. Cihazınızı Azmimilli Mahallesi'ndeki atölyemize bırakın, çoğu arıza aynı gün hazır olsun.",
    faults: [
      "Süpürge motor değişimi",
      "Ütü buhar vermiyor / kireç temizliği",
      "Mikrodalga ısıtmıyor",
      "Kahve makinesi pompa arızası",
      "Robot süpürge batarya ve tekerlek",
      "Tost / ızgara rezistansı",
      "Çay makinesi rezistans ve termostat",
      "Blender / mikser motoru",
    ],
    faqs: [
      ["Cihazı nereye teslim ediyorum?", "Azmimilli Mahallesi, Darıcı Sokak No:18'deki atölyemize bırakabilirsiniz; her gün 08:00-20:00 açığız."],
      ["Onarım ne kadar sürer?", "Parça stokta ise çoğu küçük ev aleti aynı gün veya ertesi gün teslim edilir."],
      ["Her markaya bakıyor musunuz?", "Evet, marka ayırt etmeden tüm küçük ev aletlerine bakıyoruz."],
    ],
  },
];
